<template>
  <div id="pt" class="container-24">
    <loading :show="showSpinner" label="Loading..." :overlay="true"></loading>

    <div class="container payment-container">
      <div class="row payment-section">
        <section class="col-sm-12 payment-desc-header">
          <h3 class="title-24">Manage AutoPay</h3>
          <section class="card-24">
            <div class="card-text-container">
              <div class="text-24">
                <p>
                  Update your credit card or bank information for future auto-payments. Select an agreement, then select and enter a different payment method.
                </p>
              </div>
            </div>
          </section>
        </section>
      </div>
    </div>

    <div class="container payment-container">
      <payment-table :agreementData="agreementData" v-on:change="value => {selectedAgreements = value}"></payment-table>
    </div>

    <div class="container payment-container">
      <div class="row payment-section">
        <section class="col-sm-12 payments-methods-header">
          <h3 class="title-24">Your Payment Methods</h3>

          <credit-card :value="paymentMethod.creditCardPaymentData" @input="nValue => paymentMethod.creditCardPaymentData = nValue"
                       :disabled="paymentMethod.type === 'bank'" :togglable="true" :validation-scope="'paymentMethodCC'">
            <span slot="disableHandler">
              <el-radio  class="radio" v-model="paymentMethod.type" @input="value => {togglePaymentType(value)}" label="card">
                <span></span>
              </el-radio>
            </span>
          </credit-card>

          <bank-account :value="paymentMethod.bankPaymentData" @input="nValue => paymentMethod.bankPaymentData = nValue"
                        :disabled="paymentMethod.type === 'card'" :togglable="true" :validation-scope="'paymentMethodBank'">
            <span slot="disableHandler">
              <el-radio  class="radio" v-model="paymentMethod.type" @input="value => {togglePaymentType(value)}" label="bank">
                <span></span>
              </el-radio>
            </span>
          </bank-account>

          <div id="actions">
            <div class="row bottom-cta-button">
              <div class="col-xs-12 materialized pm-confirm-button">
                <button class="btn btn-primary pull-right" v-on:click="confirmAgreementsSelectedToPay()">Confirm</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <update-open-invoices-modal v-if="showOpenInvoicesModal" @close="closeOpenInvoiceModal" @agreeUpdate="value => { handleAgree(value) }" :openInvoicesArray="openInvoices" :agreementData="agreementData" :creditCardPaymentData="paymentMethod.creditCardPaymentData"></update-open-invoices-modal>

      <mso-modal v-if="showModalTAC" :paymentData="buildPaymentData()"
                 :htmlTac="htmlTac"
                 @close="closeTacModal">
      </mso-modal>
    </div>
  </div>
</template>

<script>

  import MSOModal from './MSOModal.vue'
  import PaymentTable from './PaymentTable.vue'
  import { CreditCard, BankAccount, CreditCardDetector as creditCardType } from 'my-account-payment'
  import UpdateOpenInvoicesModal from './updateOpenInvoices/UpdateOpenInvoicesModal'
  import { ServiceContainer, loading } from 'CommonBilling'
  const paymentUpdateService = ServiceContainer.paymentUpdateService
  const payInvoicesService = ServiceContainer.payInvoicesService

  export default {
    name: 'PaymentMethods',
    components: {
      'payment-table': PaymentTable,
      'mso-modal': MSOModal,
      'loading': loading,
      'credit-card': CreditCard,
      'bank-account': BankAccount,
      'update-open-invoices-modal': UpdateOpenInvoicesModal
    },
    mounted () {
      paymentUpdateService.getTacHtml({}).then((response) => {
        this.htmlTac = response.data
      })
      payInvoicesService.getOpenInvoices({ params: { pastDueInvoices: true } }).then((response) => {
        this.openInvoices = response.data.invoices
      }).catch((error) => {
        this.getOpenInvoicesError = error
      })
      this.showSpinner = true
      paymentUpdateService.getPaymentEftAgreements({useCache: false}).then((response) => {
        this.agreementData = response.data
        this.showSpinner = false
      }).catch((error) => {
        this.showSpinner = false
        if (error.response !== undefined && error.response.data.errorMessage !== undefined) {
          this.$toasted.show('<p>' + error.response.data.errorMessage + '</p>', {
            position: 'bottom-center',
            duration: 10000
          })
        }
      })
    },
    data () {
      return {
        showOpenInvoicesModal: false,
        showSpinner: false,
        showModalTAC: false,
        htmlTac: '',
        openInvoices: [],
        getOpenInvoicesError: {},
        paymentMethod: {
          type: 'card',
          agreeTAC: false,
          creditCardPaymentData: {
            nameOnCard: '',
            cardNumber: '',
            expirationMonth: '01',
            expirationYear: 2017
          },
          bankPaymentData: {
            bankAccountType: 'SAV',
            bankName: '',
            routingNumber: '',
            nameOnAccount: '',
            accountNumber: ''
          }
        },
        selectedAgreements: [],
        agreementData: {},
        errorMessages: {
          noAgreementsSelected: '<p>Please select at least one agreement in order to process this request.</p>'
        }
      }
    },
    methods: {
      confirmAgreementsSelectedToPay () {
        if (this.selectedAgreements.length <= 0) {
          this.$toasted.show(this.errorMessages.noAgreementsSelected, {
            position: 'bottom-center',
            duration: 10000
          })
          return
        }

        let scope = this.paymentMethod.type === 'bank' ? 'paymentMethodBank' : 'paymentMethodCC'
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.showModalTAC = true
          }
        })
      },
      closeTacModal (paymentDone) {
        this.showModalTAC = false
        if (paymentDone) {
          if (this.openInvoices.length !== 0) {
            this.agreementData.kindOfPayment = this.paymentMethod.type
            this.showOpenInvoicesModal = true
          } else {
            this.buildConfirmationData([])
          }
        }
      },
      closeOpenInvoiceModal (paymentCompleted) {
        this.buildConfirmationData(paymentCompleted)
      },
      togglePaymentType (type) {
        this.paymentMethod.type = type
      },
      buildConfirmationData (agreements) {
        const confirmationData = {
          selectedEftAgreements: this.selectedAgreements,
          eftAgreements: this.agreementData,
          agreements: agreements
        }
        if (this.paymentMethod.type === 'card') {
          confirmationData.bankInformation = {
            cardNumber: this.paymentMethod.creditCardPaymentData.cardNumber.substr(-4),
            cardType: creditCardType(this.paymentMethod.creditCardPaymentData.cardNumber)[0].apiName,
            cardExpirationDate: this.paymentMethod.creditCardPaymentData.expirationMonth + '/' + this.paymentMethod.creditCardPaymentData.expirationYear.toString().substr(-2)
          }
        } else {
          confirmationData.bankInformation = {
            cardNumber: this.paymentMethod.bankPaymentData.accountNumber.substr(-4),
            cardType: this.paymentMethod.bankPaymentData.bankAccountType
          }
        }
        let confirmParams = {
          paymentData: confirmationData,
          confirmTitle: confirmationData.agreements.length === 0 ? 'AutoPay Confirmation' : 'Payment Confirmation',
          confirmDescription: confirmationData.agreements.length === 0 ? 'Update billing information for monthly dues' : 'Make a Payment',
          previousView: 'paymentMethods'
        }
        this.$router.push({name: 'PaymentMethodsConfirmation', params: confirmParams})
      },
      buildPaymentData () {
        if (this.paymentMethod.type === 'bank') {
          return {
            'agreementNumbers': this.selectedAgreements,
            'bankInformationDTO': {
              'accountNumber': this.paymentMethod.bankPaymentData.accountNumber,
              'accountType': this.paymentMethod.bankPaymentData.bankAccountType,
              'bankName': this.paymentMethod.bankPaymentData.bankName,
              'nameOnAccount': this.paymentMethod.bankPaymentData.nameOnAccount,
              'routingNumber': this.paymentMethod.bankPaymentData.routingNumber
            }
          }
        } else {
          return {
            'agreementNumbers': this.selectedAgreements,
            'bankInformationDTO': {
              'accountNumber': this.paymentMethod.creditCardPaymentData.cardNumber,
              'accountType': creditCardType(this.paymentMethod.creditCardPaymentData.cardNumber)[0].apiName,
              'creditCardExpireDate': this.paymentMethod.creditCardPaymentData.expirationMonth + '-' + this.paymentMethod.creditCardPaymentData.expirationYear,
              'nameOnAccount': this.paymentMethod.creditCardPaymentData.nameOnCard
            }
          }
        }
      },
      printPaymentMethod () {
        this.showModalTAC = false
        this.$forceUpdate()
        this.$nextTick(function () {
          window.print()
        })
      }
    }
  }
</script>

<style lang="scss">
  @import '~CommonBilling/css/variables';

  .pm-confirm-button {
      margin: 40px 0;
  }

  .payment-container {
    padding: 0 20px;
    .section-separator {
      border-bottom: 1px solid red;
      margin-top: -8px;
      margin-bottom: 1px;
      width: 100%;
    }

    .payment-section {
      margin-top: 20px;

      .card-text-container {
        padding-left: 0;
      }

    }

    select, select:disabled {
      padding-right: 75px;
    }

    .active {
      background-color: #F5F5F5;
      input, select {
        background-color: transparent;
      }
    }

    .el-select {
      width: 100%;
      .el-input__inner {
        box-shadow: none;
        border-top-width: 0;
        border-left-width: 0;
        border-right-width: 0;
        border-color: #adadad;
        border-radius: 0;
        font-size: 1.143em;
        color: #4d4e53;
        &:hover, &:focus {
          border-color: #adadad;
        }
      }
    }


  }

  .datatable-length {
    margin-left: 10px;
  }

  .opactiy-5 {
    opacity: 0.5;
  }

  .agree-section {
    border: 0 !important;
    padding: 0 !important;
    margin: 0 15px
  }

  .margin-sides-20, .logo-margin {
    margin: 0 20px;
  }

  .credit-card-text {
    margin: 0 !important;
  }

  .margin-sides-10 {
    margin: 0 10px
  }

  .margin-sides-5 {
    margin: 0 5px;
  }
  .el-select {
    width: 100%;
    .el-input__inner {
      box-shadow: none;
      border-top-width: 0;
      border-left-width: 0;
      border-right-width: 0;
      border-color: #adadad;
      border-radius: 0;
      font-size: 1.143em;
      color: #4d4e53;
      &:hover, &:focus {
        border-color: #adadad;
      }
    }
  }

  .radio {
    float: left;
  }

  .cc-logo-container {
    float: left;
    clear: right;
  }

  @media (max-width: $screen-xs-min) {
    .cc-logo-container {
      float: none;
    }
  }
  /* Small devices (phones under 768px) */
  @media (max-width: $screen-sm-min) {}

  /* Small devices (tablets, 768px and up) */
  @media (min-width: $screen-sm-min) {}

  /* Medium devices (desktops, 992px and up) */
  @media (min-width: $screen-md-min) {}

  /* Large devices (large desktops, 1200px and up) */
  @media (min-width: $screen-lg-min) {}

  @media only screen and (max-width: 600px) {}

  @media only screen and (max-width: 750px) {
    .controls-top, .controls-bottom {
      .info {
        display: inline;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// node_modules/UpdatePaymentMethods/PaymentMethods.vue